export default "__VITE_ASSET__C9iwkx1C__"